import React from "react";
import { Routes, Route } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { NotFound } from "features/shell";
import { publicRoutes } from "app/routes/publicRoutes";
import { protectedRoutes } from "app/routes/protectedRoutes";
import { mobileRoutes } from "app/routes/mobileRoutes";

function detectIsMobileDevice(): boolean {
  if (typeof window === "undefined") return isMobile;
  const isTouchDevice =
    "ontouchstart" in window ||
    (navigator.maxTouchPoints > 0 &&
      window.matchMedia("(pointer: coarse)").matches);
  return isMobile || isTouchDevice;
}

const AppRoutes: React.FC = () => {
  const isMobileDevice = detectIsMobileDevice();

  return (
    <Routes>
      {publicRoutes({ isMobileDevice })}
      {protectedRoutes({ isMobileDevice })}
      {mobileRoutes({ isMobileDevice })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
